export default __webpack_public_path__ + "static/media/photo1.a602f5e6.jpeg";